import React from 'react';
import PropTypes from 'prop-types';

const Settlements = ({ fill = '' }) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.54 1.64999H2.46002C2.02899 1.65197 1.61617 1.82407 1.31138 2.12886C1.00659 2.43365 0.834492 2.84646 0.83252 3.27749V14.7225C0.834492 15.1535 1.00659 15.5663 1.31138 15.8711C1.61617 16.1759 2.02899 16.348 2.46002 16.35H15.54C15.9711 16.348 16.3839 16.1759 16.6887 15.8711C16.9934 15.5663 17.1655 15.1535 17.1675 14.7225V3.27749C17.1655 2.84646 16.9934 2.43365 16.6887 2.12886C16.3839 1.82407 15.9711 1.65197 15.54 1.64999ZM15.54 14.7225H2.46002V3.27749H15.54V14.7225Z"
      fill={fill || 'var(--SECONDARY_LIGHT)'}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.475 7.125C14.3195 6.97336 14.1109 6.88849 13.8937 6.88849C13.6765 6.88849 13.468 6.97336 13.3125 7.125L11.3025 9.1425L10.725 8.5575C10.6502 8.48107 10.561 8.42035 10.4625 8.3789C10.3639 8.33744 10.2581 8.31608 10.1512 8.31608C10.0443 8.31608 9.93851 8.33744 9.83999 8.3789C9.74146 8.42035 9.65221 8.48107 9.57747 8.5575C9.50196 8.63275 9.44204 8.72217 9.40116 8.82063C9.36028 8.91908 9.33923 9.02464 9.33923 9.13125C9.33923 9.23786 9.36028 9.34341 9.40116 9.44187C9.44204 9.54033 9.50196 9.62975 9.57747 9.705L10.785 10.92C10.9255 11.0597 11.1156 11.1381 11.3137 11.1381C11.5119 11.1381 11.7019 11.0597 11.8425 10.92L14.4825 8.2875C14.5589 8.21098 14.6193 8.12006 14.6603 8.02002C14.7013 7.91998 14.7221 7.8128 14.7214 7.70468C14.7207 7.59657 14.6985 7.48966 14.6562 7.39016C14.6139 7.29065 14.5523 7.20053 14.475 7.125Z"
      fill={fill || 'var(--SECONDARY_LIGHT)'}
    />
    <path
      d="M6.54747 4.91249H4.09497C3.64347 4.91249 3.27747 5.2785 3.27747 5.72999C3.27747 6.18148 3.64347 6.54749 4.09497 6.54749H6.54747C6.99896 6.54749 7.36497 6.18148 7.36497 5.72999C7.36497 5.2785 6.99896 4.91249 6.54747 4.91249Z"
      fill={fill || 'var(--SECONDARY_LIGHT)'}
    />
    <path
      d="M6.54747 8.1825H4.09497C3.64347 8.1825 3.27747 8.5485 3.27747 9C3.27747 9.45149 3.64347 9.8175 4.09497 9.8175H6.54747C6.99896 9.8175 7.36497 9.45149 7.36497 9C7.36497 8.5485 6.99896 8.1825 6.54747 8.1825Z"
      fill={fill || 'var(--SECONDARY_LIGHT)'}
    />
    <path
      d="M6.54747 11.4525H4.09497C3.64347 11.4525 3.27747 11.8185 3.27747 12.27C3.27747 12.7215 3.64347 13.0875 4.09497 13.0875H6.54747C6.99896 13.0875 7.36497 12.7215 7.36497 12.27C7.36497 11.8185 6.99896 11.4525 6.54747 11.4525Z"
      fill={fill || 'var(--SECONDARY_LIGHT)'}
    />
  </svg>
);

Settlements.propTypes = {
  fill: PropTypes.string,
};

export default Settlements;
